export const GET_PERSON_AUTOCOMPLETE_LIST = 'GET_PERSON_AUTOCOMPLETE_LIST';
export const GET_PERSON_AUTOCOMPLETE_LIST_SUCCESS = `${GET_PERSON_AUTOCOMPLETE_LIST}/SUCCESS`;
export const GET_PERSON_AUTOCOMPLETE_LIST_FAILURE = `${GET_PERSON_AUTOCOMPLETE_LIST}/FAILURE`;

export default {
  GET_PERSON_AUTOCOMPLETE_LIST,
  GET_PERSON_AUTOCOMPLETE_LIST_SUCCESS,
  GET_PERSON_AUTOCOMPLETE_LIST_FAILURE
};
